import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import AccordionMenu from "./AccordionMenu";



const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const Slide1Content = ({ handleTutorialSlide }) => {

  return (
    <>
      <DemoPaper sx={{ my: .5, textAlign: "justify", p: 2 }} elevation={3} variant="elevation">
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          یادگیری زبان با استفاده از محبوب ترین سریال ها
        </Typography>
        <Typography sx={{ p: 1 }}>
          از طریق اوملنگ شما می توانید محبوب ترین سریال ها و یا جدیدترین سریال ها رو مشاهده کنید
        </Typography>
        <Typography sx={{ p: 1 }}>
          برای دریافت لینک دانلود فیلم و زیرنویس جدیدترین و محبوب ترین سریال ها نیز علاوه بر اینکه امکان جستجو در گوگل و دریافت آنها را دارید، شما می توانید در <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن اوملنگ</a>  لینک دانلود این فیلم سریال ها را پیدا کنید و یا اگر خود این لینکها را دارید با دیگر زبان آموزان به اشتراک بگذاید.
        </Typography>
        <Typography sx={{ p: 1 }}>
          اگر سریال ها را دارید اما دو زیرنویس آنها را ندارید نیز می توانید این زیرنویس ها را در <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن </a>  پیدا کنید، ضمنا این زیرنویس ها را نیز با دوستان خود به اشتراک بگذارید.
        </Typography>
        <Typography sx={{ p: 1 }}>

          <span style={{ fontWeight: "bolder" }} >پیشنهاد :</span>
          با توجه به اینکه موتور جستجوی <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن </a>  حساس به حروف است و جستجوی آن نیاز به تایپ دقیق کلمات می باشد پیشنهاد ما جستجوی نام فیلم یا سریال + عبارت اوملنگ در <a href="https://www.google.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>سایت گوگل</a>  می باشد  </Typography>
        <Typography sx={{ p: 1 }}>
          بعنوان مثال:
          زیرنویس فارسی فصل اول Friends اوملنگ  </Typography>
        <Typography sx={{ p: 1 }}>
          یا:
          لینک دانلود فیلم Oppenheimer اوملنگ  </Typography>
        <Typography sx={{ p: 1 }}>
          درصورتی که لینک مورد نظر پیدا نشد می توانید در <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن اوملنگ</a> درخواست خود را ارسال کنید
        </Typography>
      </DemoPaper>
    </>
  )
}


export default Slide1Content;
